import PropTypes from "prop-types"
import classNames from "classnames"
import { Card, CardContent, CircularProgress, Typography } from "@mui/material"
import { FiberManualRecord } from "@mui/icons-material"

import "./style.scss"

function LoadingCard({ title, visible, loading, status, children, disabled }) {
  const { color, text } = status
  return <Card square className="components_loading-card">
    <div className="header">
      <Typography variant="h2" color={!disabled ? "textPrimary" : "textSecondary"} gutterBottom>
        {title}
      </Typography>
      <div className="status">
        <div className="left">
          {loading ? <CircularProgress size="20px" color="primary" /> : <FiberManualRecord className={color} />}
        </div>
        <div className="right">
          <Typography variant="body2" color="textSecondary">{text}</Typography>
        </div>
      </div>
    </div>
    <CardContent className={classNames({ visible })}>
      {children}
    </CardContent>
  </Card>
}

LoadingCard.propTypes = {
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  status: PropTypes.shape({
    color: PropTypes.oneOf(["primary", "success", "warning", "error"]).isRequired,
    text: PropTypes.string.isRequired,
  }),
  disabled: PropTypes.bool,
}

export default LoadingCard
